// Copyright (c) StrangeBee 2024

import { ADMIN_ORG_ID, MenuProps, RouteType } from '@Types';
import { Divider, Menu } from 'antd';
import React, { ReactElement, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { UserOutput } from 'thehive-sdk';
import { UserEventList } from '@Organisms/User/eventList';

import './PrincipalMenu.scss';

type PrincipalMenuProps = {
    routes: RouteType[];
    currentUser: UserOutput;
    setIsMenuClosed?: (value: boolean) => void;
    userEventList: UserEventList;
};

const { Item } = Menu;

let lastGroup = '';

export const PrincipalMenu = ({ routes, currentUser }: PrincipalMenuProps): ReactElement => {
    const location = useLocation();

    const [menuItems, setMenuItems] = useState<MenuProps[]>([]);
    const [selectedItem, setSelectedItem] = useState<string>('');
    const { organisation } = currentUser;
    lastGroup = '';

    const isAdmin = currentUser && organisation === ADMIN_ORG_ID;
    const currentSpace = isAdmin ? 'admin' : 'user';

    useEffect(() => {
        const menu = routes.reduce((acc, { menu }): MenuProps[] => (menu ? [...acc, menu] : acc), [] as MenuProps[]);
        setMenuItems(menu);
    }, [routes]);

    useEffect(() => {
        const { pathname } = location;
        if (menuItems.length) {
            menuItems.some(({ key = '', selectTab = '' }: MenuProps): boolean => {
                if (selectTab && pathname.includes(selectTab)) {
                    setSelectedItem(key);
                    return true;
                }
                return false;
            });
        }
    }, [location, menuItems]);

    return (
        <Menu mode="inline" selectedKeys={[selectedItem]} className="principal-menu">
            {menuItems.reduce(
                (acc, { key, icon, render, space, group = '' }: MenuProps, index: number): ReactElement[] => {
                    if (space && !space.includes(currentSpace)) {
                        return acc;
                    }

                    if (lastGroup !== group) {
                        // condition to be reworked
                        lastGroup = group;
                        if (index) {
                            acc = [
                                ...acc,
                                <Item key={group} title={null}>
                                    <Divider />
                                </Item>,
                            ];
                        }
                    }

                    return render
                        ? [
                              ...acc,
                              <Item key={key} className={`th-menu_item`} icon={icon}>
                                  {render}
                              </Item>,
                          ]
                        : acc;
                },
                [] as ReactElement[],
            )}
        </Menu>
    );
};
